export const getHeaders = () => {
  let token = localStorage.getItem('access_token');

  if (!token) {
    const interval = setInterval(() => {
      if (localStorage.getItem('access_token')) {
        clearInterval(interval);
        token = localStorage.getItem('access_token');
      }
    }, 10);
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};
